import styled from 'styled-components'

export const UniqueIdWrapper = styled.div`
display: flex; 
align-items: center;
justify-content: left;
width: 75%;
 .loaderWrapper {
  position: relative; 
  margin: auto;
  margin-left: 10px; 
  margin-top: 23px; 
  margin-right: 5px;
 }
 .field {
  width: inherit !important;
 }
`
export const FormWrapper = styled.div`
 .field {
  margin-bottom: 2em !important;
 }
`